import { Component, Prop, Vue } from 'vue-property-decorator';
import type { IBankData } from '@/api/quick-bind-card/types';

import style from './index.module.scss';

@Component
export default class BankCard extends Vue {
  @Prop(Object) readonly bankData!: IBankData;

  @Prop(String) readonly productId!: string;

  private onClickBankCard() {
    this.$emit('viewAgreeProtocols');
  }

  private render() {
    const { bankName, bankLogo } = this.bankData;

    return (
      <div class={style.bankCard} onClick={() => this.onClickBankCard()}>
        <p class={style.icon} style={{ backgroundImage: `url(${bankLogo})` }} />
        <p class={style.name}>{bankName}</p>
        <p class={style.arrow} />
      </div>
    );
  }
}
